var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEpsMobileLogo = function SvgEpsMobileLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    className: "eps-mobile-logo_svg__eps-logo_svg__wrapper",
    viewBox: "0 0 99 99"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    className: "eps-mobile-logo_svg__eps-mono"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 66h33V33H33zM66 66h33V33H66zM0 66h33V33H0zM66 33h33V0H66zM33 33h33V0H33zM0 33h33V0H0zM0 99h33V66H0zM33 99h33V66H33zM66 99h33V66H66z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "eps-mobile-logo_svg__eps-color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#22353B",
    d: "M33 66h33V33H33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009CC8",
    d: "M66 66h33V33H66zM0 66h33V33H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4FC6DF",
    d: "M66 33h33V0H66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009CC8",
    d: "M33 33h33V0H33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A36CAB",
    d: "M0 33h33V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#405152",
    d: "M0 99h33V66H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A1718",
    d: "M33 99h33V66H33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E05B25",
    d: "M66 99h33V66H66z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    className: "eps-mobile-logo_svg__eps-static-white"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.125,
    d: "M13.854 13.854h74.178v74.178H13.854z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M89.085 10v79.085H10V10zm-4.65 4.67H14.681v69.667h69.754z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M36.141 34.52H34.52v29.96h1.77V35.703l12.337 23.716h.72l13.362-23.637V64.48h1.771V34.52h-1.636l-13.82 22.933z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M33 66h4.749V41.899l9.948 18.987h2.461l10.985-19.322V66H66V33h-4.033L49.085 54.336 36.975 33H33z"
  }))));
};
export default SvgEpsMobileLogo;